import { ForgotPasswordPhoneViewModel } from '@apis/model';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { ForgotPasswordPhoneResponse } from '@ul/api/lib/models/ForgotPasswordPhoneResponse';

export const toForgotPasswordPhoneViewModel = (
    forgotPasswordResponse: ForgotPasswordPhoneResponse
): ForgotPasswordPhoneViewModel => {
    const { success, responseCode, token } = forgotPasswordResponse;
    return {
        responseCode,
        success,
        token,
        captchaViewModel: toCaptchaViewModel(forgotPasswordResponse),
        otpViewModel: toOtpViewModel(forgotPasswordResponse),
    };
};
